import { render, staticRenderFns } from "./itemTitle.vue?vue&type=template&id=be78205e&scoped=true&"
import script from "./itemTitle.vue?vue&type=script&lang=js&"
export * from "./itemTitle.vue?vue&type=script&lang=js&"
import style0 from "./itemTitle.vue?vue&type=style&index=0&id=be78205e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be78205e",
  null
  
)

export default component.exports